var map = {
	"./all.png": 7871,
	"./farming.png": 139,
	"./fighting.png": 5088,
	"./fishing.png": 118,
	"./hunting.png": 2371,
	"./logging.png": 5534,
	"./mining.png": 3875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4206;